import { Cartridge, Nes }                       from '@/Emulator';
import { IComponent }                           from '@/Interface/IComponent';
import { Component, h, Host, JSX, Prop, State } from '@stencil/core';

@Component({
    tag:      'nes-debugger',
    styleUrl: './nes-debugger.scss',
    shadow:   true,
})
export class NesDebugger implements IComponent
{
    @Prop() public nes!: Nes;

    /**
     * @inheritDoc
     */
    public render(): JSX.Element
    {
        return (
            <Host>
                <nes-debugger-frame label="Cartridge">
                    <nes-cartridge-debugger nes={this.nes}/>
                </nes-debugger-frame>
                <nes-debugger-frame label="CPU">
                    <nes-cpu-debugger nes={this.nes}/>
                </nes-debugger-frame>
            </Host>
        );
    }
}
